module.exports = __webpack_public_path__ + "img/notify.398fdf0b.svg";